// extracted by mini-css-extract-plugin
export var cardContainer = "_ox-0";
export var cardHeader = "_ox-2";
export var collapsedState = "_ox-3";
export var dragHandle = "_ox-5";
export var dragHandleIcon = "_ox-6";
export var dragging = "_ox-1";
export var titleArea = "_ox-4";